var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "email-enter-title-window",
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            width: "420px",
            title: _vm.$t("Clearing.SendEmail")
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              _vm.innerVisible = false
            }
          }
        },
        [
          _c(
            "div",
            [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.rowData.length === 0
                        ? _vm.$t("Clearing.N1ContactAndEmailMaintained")
                        : _vm.$t("Clearing.N1AMaintainedContactEmail")
                    )
                )
              ]),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "padding-left": "20px" },
                  attrs: { no: "cc" },
                  on: { change: _vm.ccChangeHandler },
                  model: {
                    value: _vm.cc,
                    callback: function($$v) {
                      _vm.cc = $$v
                    },
                    expression: "cc"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SendCc")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c("cargo-ag-grid", {
                style: { width: "380px", height: "150px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "55px" } },
            [
              _c(
                "el-form",
                [
                  _c("el-form-item", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Clearing.N2PleaseAddOtherEmails")))
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Clearing.MultipleShouldBeSeparatedCommas")
                        )
                      )
                    ])
                  ]),
                  _c(
                    "el-form-item",
                    { staticClass: "el-form-item-textarea" },
                    [
                      _c("el-input", {
                        attrs: { no: "1", type: "textarea" },
                        model: {
                          value: _vm.mailInpuTextArea,
                          callback: function($$v) {
                            _vm.mailInpuTextArea = $$v
                          },
                          expression: "mailInpuTextArea"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "2", type: "primary" },
                    on: { click: _vm.sendButtonClick }
                  },
                  [_vm._v(_vm._s(_vm.$t("Clearing.Send")))]
                ),
                _c(
                  "el-button",
                  { attrs: { no: "3" }, on: { click: _vm.closeHandler } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }